{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Applications",
    "back": "Back",
    "campaigns": "Campaigns",
    "dashboard": "Dashboard",
    "devices": "S4 local station",
    "dtwins": {
      "label": "Devices",
      "manage": {
        "fleets": "Fleets",
        "label": "Manage",
        "devices": "Devices"
      },
      "overview": {
        "label": "Overview",
        "map": "Map"
      }
    },
    "logout": "Logout",
    "logs": "Logs",
    "overview": "Overview",
    "parameters": {
      "label": "Parameters",
      "platformMgt": "Platform management",
      "features": {
        "applicationManagement": "Applications",
        "firmwareManagement": "Firmware",
        "deviceConfiguration": "Device configuration",
        "label": "Features",
        "licenseManagement": "License",
        "interfaces": "Interfaces"
      },
      "monitoring": {
        "label": "Monitoring",
        "settings": "Reporting"
      }
    },
    "product": "Product",
    "sector": {
      "label": "Sector",
      "placeholder": "Select sector"
    },
    "sectors": "Sectors",
    "settings": "Administration",
    "users": "Users"
  },
  "header": {
    "sectors": "Sectors",
    "userMenu": {
      "title": "Account menu",
      "logout": "Log out",
      "userAccount": "User account",
      "about": "About",
      "connectMyMobileApp": "Connect my mobile app"
    },
    "admin": "Administration",
    "delegation": {
      "select": {
        "label": "Select an organization",
        "title": "Select an organization"
      }
    }
  }
}
